import { MappedTranslations } from '@hellodarwin/core/lib/features/entities/translations-entities';
import alertsEn from './en/alerts.json';
import documentJourneyEn from './en/document-journey.json';
import onboardingEn from './en/onboarding.json';
import projectEn from './en/project.json';
import propulsionEn from './en/propulsion.json';
import resourceEn from './en/resource.json';
import rfpEn from './en/rfp.json';
import vaultEn from './en/vault.json';
import alertsFr from './fr/alerts.json';
import documentJourneyFr from './fr/document-journey.json';
import onboardingFr from './fr/onboarding.json';
import projectFr from './fr/project.json';
import propulsionFr from './fr/propulsion.json';
import resourceFr from './fr/resource.json';
import rfpFr from './fr/rfp.json';
import vaultFr from './fr/vault.json';
import assetsEn from '../../../content/locales/en/assets.json';
import assistantEn from '../../../content/locales/en/assistant.json';
import commonEn from '../../../content/locales/en/common.json';
import confirmModalEn from '../../../content/locales/en/confirm-modal.json';
import errorsEn from '../../../content/locales/en/errors.json';
import grantsEn from '../../../content/locales/en/grants.json';
import langEn from '../../../content/locales/en/lang.json';
import portfolioEn from '../../../content/locales/en/portfolio.json';
import profileEn from '../../../content/locales/en/profile.json';
import programsEn from '../../../content/locales/en/programs.json';
import projectSingleEn from '../../../content/locales/en/project-single.json';
import providerProfileEn from '../../../content/locales/en/provider-profile.json';
import reviewsEn from '../../../content/locales/en/reviews.json';
import tagsEn from '../../../content/locales/en/tags.json';
import teamEn from '../../../content/locales/en/team.json';
import timeTrackingEn from '../../../content/locales/en/time-tracking.json';
import assetsFr from '../../../content/locales/fr/assets.json';
import assistantFr from '../../../content/locales/fr/assistant.json';
import commonFr from '../../../content/locales/fr/common.json';
import confirmModalFr from '../../../content/locales/fr/confirm-modal.json';
import errorsFr from '../../../content/locales/fr/errors.json';
import grantsFr from '../../../content/locales/fr/grants.json';
import langFr from '../../../content/locales/fr/lang.json';
import portfolioFr from '../../../content/locales/fr/portfolio.json';
import profileFr from '../../../content/locales/fr/profile.json';
import programsFr from '../../../content/locales/fr/programs.json';
import projectSingleFr from '../../../content/locales/fr/project-single.json';
import providerProfileFr from '../../../content/locales/fr/provider-profile.json';
import reviewsFr from '../../../content/locales/fr/reviews.json';
import tagsFr from '../../../content/locales/fr/tags.json';
import teamFr from '../../../content/locales/fr/team.json';
import timeTrackingFr from '../../../content/locales/fr/time-tracking.json';

type SupportedLocale = 'en' | 'fr';

const translationsByLocale: Record<SupportedLocale, MappedTranslations> = {
  en: {
    alerts: alertsEn,
    'document-journey': documentJourneyEn,
    project: projectEn,
    propulsion: propulsionEn,
    resource: resourceEn,
    onboarding: onboardingEn,
    rfp: rfpEn,
    common: commonEn,
    errors: errorsEn,
    reviews: reviewsEn,
    'provider-profile': providerProfileEn,
    profile: profileEn,
    team: teamEn,
    portfolio: portfolioEn,
    tags: tagsEn,
    lang: langEn,
    'confirm-modal': confirmModalEn,
    'project-single': projectSingleEn,
    programs: programsEn,
    grants: grantsEn,
    assets: assetsEn,
    assistant: assistantEn,
    'time-tracking': timeTrackingEn,
    vault: vaultEn,
  } as unknown as MappedTranslations,
  fr: {
    alerts: alertsFr,
    'document-journey': documentJourneyFr,
    project: projectFr,
    propulsion: propulsionFr,
    resource: resourceFr,
    onboarding: onboardingFr,
    rfp: rfpFr,
    common: commonFr,
    errors: errorsFr,
    reviews: reviewsFr,
    'provider-profile': providerProfileFr,
    profile: profileFr,
    team: teamFr,
    portfolio: portfolioFr,
    tags: tagsFr,
    lang: langFr,
    'confirm-modal': confirmModalFr,
    'project-single': projectSingleFr,
    programs: programsFr,
    grants: grantsFr,
    assets: assetsFr,
    assistant: assistantFr,
    'time-tracking': timeTrackingFr,
    vault: vaultFr,
  } as unknown as MappedTranslations,
};

export const getLocaleNamespaces = (locale: string): MappedTranslations => {
  if (locale !== 'en' && locale !== 'fr') {
    throw new Error(`Unsupported Client locale: ${locale}`);
  }

  return translationsByLocale[locale];
};
